/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OkInputs */

const en_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ar_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موافق`)
};

const de_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const es_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ja_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ko_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

const pt_br_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОК`)
};

const th_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตกลง`)
};

const tr_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamam`)
};

const zh_cn_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解`)
};

const zh_tw_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {OkInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const ok = /** @type {((inputs?: OkInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OkInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ok(inputs)
	if (locale === "ar") return ar_ok(inputs)
	if (locale === "de") return de_ok(inputs)
	if (locale === "es") return es_ok(inputs)
	if (locale === "fr") return fr_ok(inputs)
	if (locale === "it") return it_ok(inputs)
	if (locale === "ja") return ja_ok(inputs)
	if (locale === "ko") return ko_ok(inputs)
	if (locale === "pt_br") return pt_br_ok(inputs)
	if (locale === "ru") return ru_ok(inputs)
	if (locale === "th") return th_ok(inputs)
	if (locale === "tr") return tr_ok(inputs)
	if (locale === "zh_cn") return zh_cn_ok(inputs)
	return zh_tw_ok(inputs)
});